<header class="custom-header">
  <div class="m-header" [style.display]="this.headerStyle">
    <a class="mobile-menu" id="mobile-collapse1" href="javascript:" (click)="this.onNavCollapsedMob.emit();"><span></span></a>
    <a [routerLink]="['/admin/dashboard']" class="b-brand">
      <div class="logoImage">
        <img src="assets/images/indiapost.png" alt="isu">
      </div>
      <span class="b-title">India Post</span>
    </a>
  </div>
  <a class="mobile-menu" [ngClass]="{'on' : this.menuClass}" id="mobile-header" href="javascript:"
    (click)="toggleMobOption()"><i class="feather icon-more-horizontal"></i></a>
  <div class="collapse navbar-collapse" [style.display]="this.collapseStyle">
    <app-nav-left class="mr-auto" [style.display]="this.headerStyle"></app-nav-left>
    <app-nav-right class="ml-auto" [userData]="userData"></app-nav-right>
  </div>
</header>
